export default require("../../../lib/webpack/emoji-loader!../../../vendor/emojis/img-buildkite-64.json");
